module.exports = __webpack_public_path__ + "img/20190523204555微信截图_20190523204925.47f74327.png";